import ReactGA from "react-ga4";

const GA_MEASUREMENT_ID = "G-PK8LVNGMD1";

const isConfigured = () => {
  return !!GA_MEASUREMENT_ID && GA_MEASUREMENT_ID !== "G-XXXXXXXXXX";
};

export const initGA = () => {
  if (!isConfigured()) {
    console.warn("GA4 is not initialized. Invalid Measurement ID.");
    return;
  }

  try {
    ReactGA.initialize(GA_MEASUREMENT_ID, {
      testMode: process.env.NODE_ENV === 'test',
      gaOptions: {
        siteSpeedSampleRate: 100
      }
    });
    console.log("GA4 Initialized with ID:", GA_MEASUREMENT_ID);
  } catch (error) {
    console.error("GA4 Initialization failed:", error);
  }
};

export const logPageView = () => {
  if (!isConfigured()) return;
  try {
    ReactGA.send({ hitType: "pageview", page: window.location.pathname });
  } catch (error) {
    console.error("GA4 logPageView failed:", error);
  }
};

export const logEvent = (category, action, label) => {
  if (!isConfigured()) return;
  try {
    ReactGA.event({
      category,
      action,
      label,
    });
  } catch (error) {
    console.error("GA4 logEvent failed:", error);
  }
};

export const setUserProperties = (properties) => {
  if (!isConfigured()) return;
  try {
    ReactGA.gtag("set", "user_properties", properties);
  } catch (error) {
    console.error("GA4 setUserProperties failed:", error);
  }
};

// Advanced: Enhanced Ecommerce (Example)
export const logPurchase = (transactionId, value, currency, items) => {
  if (!isConfigured()) return;
  try {
    ReactGA.gtag("event", "purchase", {
      transaction_id: transactionId,
      value,
      currency,
      items,
    });
  } catch (error) {
    console.error("GA4 logPurchase failed:", error);
  }
};
